const footerMenuList = [
  {
    id: 1,
    title: "Apps",
    diffClass: "md:col-start-9",
    list: [
      {
        id: 1,
        href: "https://logri.bluequanta.io",
        text: "Logri",
      },
      {
        id: 2,
        href: "https://croft.bluequanta.io",
        text: "Croft",
      },
      {
        id: 3,
        href: "https://piano-pals.bluequanta.io",
        text: "Piano Pals",
      },
    ],
  },
  {
    id: 2,
    title: "Company",
    diffClass: "",
    list: [
      {
        id: 1,
        href: "/",
        text: "Home",
      },
      {
        id: 2,
        href: "/blog",
        text: "Blog",
      },
      {
        id: 3,
        href: "/about",
        text: "About",
      },
      {
        id: 4,
        href: "/contact",
        text: "Contact Us",
      },
    ],
  },
];

const socialIcons = [
  {
    id: 1,
    href: "https://www.instagram.com/blue.quanta",
    text: "instagram",
  },
];

export { footerMenuList, socialIcons };
